var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationCapLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5L3 9.75L12 4.5L21 9.75V16.125H19.5V10.625L18 11.5V16.5085L17.833 16.7148C16.4593 18.4124 14.3563 19.5 12 19.5C9.64363 19.5 7.54072 18.4124 6.16697 16.7148L6 16.5085V11.5ZM7.5 12.375V15.9688C8.60041 17.2155 10.2083 18 12 18C13.7917 18 15.3996 17.2155 16.5 15.9688V12.375L12 15L7.5 12.375ZM5.97695 9.75L12 13.2634L18.023 9.75L12 6.23656L5.97695 9.75Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCapLine);
export default __webpack_public_path__ + "static/media/graduation-cap-line.a0631e2e992d39b835b1ad9c04517cce.svg";
export { ForwardRef as ReactComponent };